module.exports = __webpack_public_path__ + "static/media/0104.97144375.png";